module.exports = __webpack_public_path__ + "static/img/banner-bg.4fa9052c.png";